import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LinkCards } from "@/components/cms/Related";

export default function ProductServices({ productId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!productId) return;
    api.get(`/services/for-product/${productId}`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [productId]);
  if (!items.length) return null;
  return <div className="mt-12 max-w-4xl"><LinkCards items={items} title="Installation & support services" testid="pdp-services" /></div>;
}
